import { Component, Input, OnInit } from '@angular/core';
import { DocumentsService } from '../../services/documents.service';
import { RolesEnum, RolesEnumGroups } from '../../ngxs/app/app.state.model';
import { AppState } from '../../ngxs/app/app.state';
import { Store } from '@ngxs/store';
import { WorkDocument, WorkProjectsService } from '../../_generated/work-rest-api';

/**
 * Bestellung eines Projekts, nur ab Stufe Projektleiter.
 *
 * Diese Komponente zeigte früher zusätzlich eine Dokumentenliste anhand einer hartcodierten
 * Documenttype-Whitelist. Die ist durch die Projektdossiers ersetzt (`ax-project-dossiers`), die
 * dasselbe konfigurierbar und rollenbezogen abbilden. Geblieben ist die Bestellung: sie hängt an
 * einer Rollenstufe und nicht an einem Dossier, deshalb wäre sie dort nicht sauber abbildbar.
 */
@Component({
  selector: 'ax-project-documents-for-employees',
  templateUrl: './ax-project-documents-for-employees.component.html',
  styleUrls: ['./ax-project-documents-for-employees.component.scss'],
})
export class AxProjectDocumentsForEmployeesComponent implements OnInit {
  @Input() projectId: number;
  public accordionStates: any = {};
  public documentBestellung: WorkDocument | undefined;
  public isAbStufeProjektleiter = false;
  private roles$ = this.store.select(AppState.roles);

  constructor(
    private readonly axProjectsService: WorkProjectsService,
    private readonly documentsService: DocumentsService,
    private readonly store: Store,
  ) {
  }

  ngOnInit() {
    this.roles$.subscribe(roles => {
      const isAbStufeProjektleiter = () =>
        roles.some((role: RolesEnum) =>
          [
            ...RolesEnumGroups.ab_stufe_abteilungsleiter,
            RolesEnum.projektleiter,
          ].includes(role),
        );
      this.isAbStufeProjektleiter = isAbStufeProjektleiter();
      if (!this.isAbStufeProjektleiter) {
        return;
      }
      this.axProjectsService.projectsV1ControllerGetDocumentsForProject({ id: this.projectId }).subscribe({
        next: documents => {
          this.documentBestellung = documents
            .filter((document) => document.active === true)
            .find((document) => document.documenttypeId === 13 || document.documenttypeId === 30 || document.documenttypeId === 60);
        },
      });
    });
  }

  public async openPdf(document: WorkDocument) {
    await this.documentsService.openPdf(document);
  }
}
